import { TFunction } from "i18next";

const formatCoolOffTime = (coolOffTime: number | undefined, t: TFunction) => {
  if (!coolOffTime || coolOffTime <= 0) return "";

  const hours = Math.floor(coolOffTime / 60);
  const minutes = coolOffTime % 60;

  if (hours > 0 && minutes > 0) {
    return `${t("assessment.time.hour", { count: hours })} ${t("assessment.time.minute", { count: minutes })}`;
  }

  if (hours > 0) {
    return t("assessment.time.hour", { count: hours });
  }

  return t("assessment.time.minute", { count: minutes });
};

export default formatCoolOffTime;
